import { Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ChartComponent } from 'ng-apexcharts';
import { PageResult } from 'src/app/common/interfaces/paged-result.interface';
import { AllMinuteResponse } from '../../files-clients/sub-page/minutes/interface/minute-request.interface';
import { getMinuteStyleByState } from 'src/app/common/custom-style';
import { environment } from 'src/environments/enviroments';

@Component({
  selector: 'app-minutes-table',
  templateUrl: './minutes-table.component.html',
  styleUrls: ['./minutes-table.component.scss']
})
export class MinutesTableComponent {
  @ViewChild('chart') chart: ChartComponent = Object.create(null);
  @ViewChild(MatSort, { static: true }) sort: MatSort = Object.create(null);
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator = Object.create(null);
  public dataSource!: MatTableDataSource<any>;
  @Output() changePagination = new EventEmitter<any>();
  @Output() changeSorting = new EventEmitter<string>;
  @Input() recieveFilterName: PageResult<AllMinuteResponse>;
  @Input() booleanFlag: boolean;
  @Input() booleanText: boolean;

  displayedColumns: string[] = [
    'MinuteRequestId',
    'CompanyName',
    'CreatedAt',
    'warrantyLine',
    'factoringLine',
    'MinuteState',
  
  ];

  constructor(private router: Router, private dialog: MatDialog) { }

  ngAfterViewInit(): void { }

  ngOnInit() {
    this.setDataSource(this.recieveFilterName);
    this.paginator._intl.itemsPerPageLabel = 'items por pagina';
  }

  ngOnChanges(changes: SimpleChanges) {
    this.setDataSource(this.recieveFilterName);
    if (changes['recieveFilterName']) {
      const newDeptorsFilter = changes['recieveFilterName'].currentValue;
      this.setDataSource(newDeptorsFilter);
    }
  }

  private setDataSource(dataSource: PageResult<AllMinuteResponse>) {
    const {sortColumn, sortDirection} = dataSource;
    this.dataSource = new MatTableDataSource<AllMinuteResponse>(dataSource?.results);
    this.paginator.length = dataSource?.totalRows;
    if(sortColumn && sortDirection){
      this.sort.active = sortColumn;
      this.sort.direction = sortDirection === 'asc' ? 'asc' : 'desc';
    }
  }

  public changePaginationTable(event: PageEvent) {
    this.changePagination.emit({
      page: event.pageIndex + 1,
      size: event.pageSize,
    });
  }

  public changeSortingTable(sortState: Sort) {
    if(sortState.direction === '') {
      this.changeSorting.emit('');
      return;
    }
    const sortOrder = `${sortState.active}_${sortState.direction}`;
    this.changeSorting.emit(sortOrder);
  }

  /*public openMinute(idMinute: any) {
    this.router.navigate(['dashboards/minutes'], {
      queryParams: { id: + idMinute },
    });
  }*/

  public redirectMinute(minuteRequestId: number) {
    if(minuteRequestId <= environment.nminutelimitold) 
    {
      this.redirectToOldMinute(minuteRequestId);
    }
    else
    {
      this.redirectToNewMinute(minuteRequestId);
    }
  }

  public redirectToOldMinute(minuteRequestId: number) {
    this.router.navigate(['dashboards/old-minute'], {
      queryParams: { id: +minuteRequestId },
    });
  }

  public redirectToNewMinute(minuteRequestId: number) {
    this.router.navigate(['dashboards/minute'], {
      queryParams: { id: +minuteRequestId },
    });
  }

  public setMinuteStyle(minuteState: string): unknown {
    return getMinuteStyleByState(minuteState);
  }

}
